import { QueryClient, useQuery, UseQueryResult } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import {
    AGENT_SOFTWARE_ID,
    AGENT_FIRST_NAME,
    AGENT_LAST_NAME,
    MANTY_STATUS,
    JOB_LABEL,
    ORG_CHART_HR_NAME,
} from 'routes/HumanResourcesModule/business/definitions';

import { Response } from 'routes/HumanResourcesModule/business/types';
import { START_DATE } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/helpers/constants';
import { INCREASE_PERCENTAGE } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/EchelonsOverview/helpers/constants';

export type SmicDataBase = {
    [AGENT_SOFTWARE_ID]: string;
    [AGENT_FIRST_NAME]: string;
    [AGENT_LAST_NAME]: string;
    [START_DATE]: string;
    [MANTY_STATUS]: string;
    [JOB_LABEL]: string;
    [ORG_CHART_HR_NAME]: string;
    [INCREASE_PERCENTAGE]: number;
};
export const AFFECTED_AGENTS_BY_SMIC_API_KEY = 'affected_agents_by_smic';

export const invalidateSmicAgentsQueries = (
    queryClient: QueryClient,
    hrSimulationId: number,
) => {
    queryClient.invalidateQueries({
        queryKey: [AFFECTED_AGENTS_BY_SMIC_API_KEY, hrSimulationId],
    });
};
export const useGetHrSimulationAffectedAgentsBySmic = (
    hrSimulationId: number,
): UseQueryResult<SmicDataBase[]> =>
    useQuery({
        queryKey: [AFFECTED_AGENTS_BY_SMIC_API_KEY, hrSimulationId],
        queryFn: async () => {
            const response = await RQAPICallWithData<Response<SmicDataBase[]>>({
                endpoint: `human_resources/hr_simulation/${hrSimulationId}/affected_agents_by_smic`,
            });
            return response.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });
